type SectionHeadingProps = {
  index: string;
  label: string;
  title: string;
  align?: "left" | "right";
};

const SectionHeading = ({
  index,
  label,
  title,
  align = "left",
}: SectionHeadingProps) => (
  <header className={`section-heading section-heading--${align}`} data-reveal>
    <div className="section-heading__meta">
      <span>{index}</span>
      <span>{label}</span>
    </div>
    <h2>{title}</h2>
  </header>
);

export default SectionHeading;
